/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Address_LabelInputs */

const en_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address:`)
};

const de_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschrift:`)
};

const fr_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse :`)
};

const es_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección:`)
};

const it_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo:`)
};

const nl_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres:`)
};

const pl_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres:`)
};

const fi_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osoite:`)
};

const da_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse:`)
};

const sv_impressum_address_label = /** @type {(inputs: Impressum_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adress:`)
};

/**
* | output |
* | --- |
* | "Address:" |
*
* @param {Impressum_Address_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_address_label = /** @type {((inputs?: Impressum_Address_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Address_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_address_label(inputs)
	if (locale === "fr") return fr_impressum_address_label(inputs)
	if (locale === "es") return es_impressum_address_label(inputs)
	if (locale === "it") return it_impressum_address_label(inputs)
	if (locale === "nl") return nl_impressum_address_label(inputs)
	if (locale === "pl") return pl_impressum_address_label(inputs)
	if (locale === "fi") return fi_impressum_address_label(inputs)
	if (locale === "da") return da_impressum_address_label(inputs)
	if (locale === "sv") return sv_impressum_address_label(inputs)
	return en_impressum_address_label(inputs)
});